export default __webpack_public_path__ + "static/media/Boots of Swiftstriking.47a016fa.jpg";